var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    { staticClass: "content_top" },
    [
      _c(
        "el-steps",
        {
          attrs: {
            active: _vm.currentStep * 1,
            "align-center": "",
            "finish-status": "success",
            "show-icon": "",
          },
        },
        [
          _c("el-step", { attrs: { title: "保单录入" } }),
          _c("el-step", { attrs: { title: "信息确认" } }),
          _c("el-step", { attrs: { title: "保单支付" } }),
          _c("el-step", { attrs: { title: "完成投保" } }),
        ],
        1
      ),
      _c(
        "el-row",
        {
          staticStyle: { "margin-top": "15px", height: "55px" },
          attrs: { justify: "center", type: "flex" },
        },
        [_c("h2", [_vm._v(_vm._s(_vm.productName))])]
      ),
      _c(
        "el-tabs",
        {
          attrs: { "tab-position": "top" },
          model: {
            value: _vm.currentStep,
            callback: function ($$v) {
              _vm.currentStep = $$v
            },
            expression: "currentStep",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "", name: "0" } },
            [
              !_vm.isEndorsement
                ? _c(
                    "el-card",
                    [
                      _c(
                        "div",
                        { attrs: { slot: "header" }, slot: "header" },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.onGetTitleContent[0])),
                          ]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: _vm.onGetTitleContent[2],
                                disabled: !_vm.product.holder.holderOnly,
                                effect: "light",
                                placement: "top",
                              },
                            },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: {
                                    float: "right",
                                    padding: "4px 0",
                                  },
                                  attrs: {
                                    disabled: _vm.product.holder.holderOnly,
                                  },
                                  on: { change: _vm.handleSameUnitChanged },
                                  model: {
                                    value: _vm.formSubmit.sameUnit,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formSubmit, "sameUnit", $$v)
                                    },
                                    expression: "formSubmit.sameUnit",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.onGetTitleContent[1]) +
                                      "\n\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.product.holder.showSelfEmployed
                        ? _c("el-alert", {
                            staticStyle: { "margin-bottom": "10px" },
                            attrs: {
                              title: _vm.unitHint,
                              "show-icon": "",
                              type: "warning",
                            },
                          })
                        : _vm._e(),
                      _c("unit-form", {
                        ref: "holder",
                        attrs: {
                          insureTypeTemp: _vm.product.type,
                          "my-insure-confirm": _vm.myInsureConfirm,
                          priceHintData: {
                            totalPrice: _vm.totalPrice,
                            isEmployeeSubmitted: _vm.formEmployee.isSubmitted,
                          },
                          productId: _vm.product.id,
                          showCategory: _vm.product.holder.showCategory,
                          showIndustry: _vm.product.holder.showIndustry,
                          unitType: _vm.formSubmit.sameUnit ? "0" : "1",
                        },
                        on: {
                          onChangeInure: _vm.onChangeInure,
                          onChangeProductId: _vm.onChangeProductId,
                          onGoToTop: _vm.onGoToTop,
                          onSubmitted: _vm.onHolderSubmitted,
                          onUnsubmitted: function ($event) {
                            _vm.formSubmit.isHolderSubmitted = false
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isEndorsement && !_vm.formSubmit.sameUnit
                ? _c(
                    "el-card",
                    {
                      attrs: {
                        header: "被保企业（上传营业执照可自动识别企业信息）",
                      },
                    },
                    [
                      _c("unit-form", {
                        ref: "insured",
                        attrs: {
                          insureTypeTemp: _vm.product.type,
                          productId: _vm.product.id,
                          showCategory: _vm.product.holder.showCategory,
                          showIndustry: _vm.product.holder.showIndustry,
                          unitType: "2",
                        },
                        on: {
                          onChangeInure: _vm.onChangeInure,
                          onChangeProductId: _vm.onChangeProductId,
                          onSubmitted: _vm.onInsuredSubmitted,
                          onUnsubmitted: function ($event) {
                            _vm.formSubmit.isInsuredSubmitted = false
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isEndorsement
                ? _c("file-confirm", {
                    ref: "refFiles",
                    attrs: {
                      insureType: _vm.product.type,
                      productId: _vm.product.id,
                    },
                    on: { onChangeProductId: _vm.onChangeProductId },
                  })
                : _vm._e(),
              _vm.product.isShowInsuredList
                ? _c("unit-insured-form", {
                    ref: "unitInsured",
                    staticStyle: { "margin-bottom": "20px" },
                    attrs: {
                      "holder-code": _vm.formSubmit.toubao.unit_code,
                      productId: _vm.product.id,
                    },
                  })
                : _vm._e(),
              _c(
                "el-card",
                { attrs: { header: "投保方案" } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("div", [_vm._v("方案选择")]),
                          _c("plan-form", {
                            ref: "plan",
                            attrs: {
                              coverageNotice: _vm.product.plan.coverageNotice,
                              insureType: _vm.product.type,
                              planCoverage: _vm.planCoverage,
                              productCode: _vm.productCode,
                              productId: _vm.product.id,
                              readOnly: _vm.isEndorsement,
                            },
                            on: {
                              categoryFiltered: _vm.onCategoryFiltered,
                              insureSuddenDeath: _vm.onInsureSuddenDeath,
                              levelChange: _vm.onProfessionLevelChange,
                              onPlanChangeAddMaim: _vm.onPlanChangeAddMaim,
                              onSubmitted: _vm.onPlanSubmitted,
                              onUnsubmitted: function ($event) {
                                _vm.formSubmit.isPlanSubmitted = false
                              },
                              planChange: _vm.onPlanChanged,
                            },
                          }),
                        ],
                        1
                      ),
                      !_vm.isEndorsement
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("div", [_vm._v("生效时间")]),
                              _c("period-form", {
                                ref: "period",
                                attrs: {
                                  maxEffectiveDate: _vm.maxEffectiveDate,
                                  minEffectiveDate: _vm.minEffectiveDate,
                                  periodListTemp: _vm.product.period.periodList,
                                },
                                on: {
                                  onSubmitted: _vm.onPeriodSubmitted,
                                  onUnsubmitted: function ($event) {
                                    _vm.formSubmit.isPeriodSubmitted = false
                                  },
                                  periodChange: _vm.onPeriodChanged,
                                },
                              }),
                            ],
                            1
                          )
                        : _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("div", [_vm._v("生效时间")]),
                              _c("period-endorse-form", {
                                ref: "periodEndorse",
                                attrs: {
                                  basePrice: _vm.endorseBasePrice,
                                  insureType: _vm.product.type,
                                  maxEffectiveDate: _vm.maxEffectiveDate,
                                  minEffectiveDate: _vm.minEffectiveDate,
                                  shortRatesList: _vm.shortRatesList,
                                },
                                on: {
                                  onSubmitted: _vm.onPeriodSubmitted,
                                  onUnsubmitted: function ($event) {
                                    _vm.formSubmit.isPeriodSubmitted = false
                                  },
                                  periodChange: _vm.calcAllEmployeePremium,
                                },
                              }),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.product.isInsureCar
                ? _c("car-form", {
                    ref: "carForm",
                    attrs: {
                      formSubmit: _vm.formSubmit,
                      tableLoading: _vm.employeeLoading,
                    },
                    on: { onSubmitCarData: _vm.onSubmitCarData },
                  })
                : _vm._e(),
              _vm.isInitOver && !_vm.product.isInsureCar
                ? _c(
                    "el-card",
                    { attrs: { header: "投保人员" } },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _c("span", [_vm._v("被保险人")]),
                      ]),
                      [
                        _c(
                          "el-row",
                          [
                            _c(
                              "avue-crud",
                              {
                                ref: "crud",
                                attrs: {
                                  data: _vm.dataEmployee,
                                  option: _vm.optionEmployee,
                                  page: _vm.page,
                                  "table-loading": _vm.employeeLoading,
                                },
                                on: {
                                  "update:page": function ($event) {
                                    _vm.page = $event
                                  },
                                  "cell-mouse-leave":
                                    _vm.employeeCellMouseLeave,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "profession",
                                      fn: function (scope) {
                                        return [
                                          _c("el-cascader", {
                                            attrs: {
                                              disabled:
                                                _vm.formEmployee.isSubmitted,
                                              filterable: true,
                                              options: _vm.optionsProfession,
                                              props: {
                                                value: "categoryCode",
                                                label: "categoryName",
                                              },
                                              "show-all-levels": false,
                                              placeholder: "请选择 职业",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.handleProfessionChange(
                                                  scope.row
                                                )
                                              },
                                            },
                                            model: {
                                              value: scope.row.profession,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "profession",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row.profession",
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                    {
                                      key: "feeRate",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                disabled:
                                                  _vm.formEmployee
                                                    .isSubmitted ||
                                                  scope.row.feeRateDisabled,
                                                placeholder: "请选择是否涉高",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.onFeeRateChange(
                                                    scope.row
                                                  )
                                                },
                                              },
                                              model: {
                                                value: scope.row.feeRate,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "feeRate",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.feeRate",
                                              },
                                            },
                                            _vm._l(
                                              _vm.feeRateDicData,
                                              function (item) {
                                                return _c("el-option", {
                                                  key: item.value,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.value,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1915869486
                                ),
                              },
                              [
                                !_vm.product.employee.maxEmployeeCount
                                  ? _c(
                                      "template",
                                      { slot: "menuRight" },
                                      [
                                        _c(
                                          "el-upload",
                                          {
                                            ref: "upload",
                                            staticStyle: {
                                              display: "inline-block",
                                              float: "right",
                                            },
                                            attrs: {
                                              "auto-upload": false,
                                              "on-change":
                                                _vm.handleEmployeeFileChange,
                                              "show-file-list": false,
                                              accept:
                                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",
                                              action: "",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                staticClass: "el-icon-upload2",
                                                attrs: { type: "primary" },
                                              },
                                              [_vm._v("批量上传")]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              loading: _vm.isDownLoading,
                                            },
                                            on: {
                                              click:
                                                _vm.handleGetEmployeeTemplate,
                                            },
                                          },
                                          [_vm._v("模板")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          { attrs: { justify: "end", type: "flex" } },
                          [
                            _c("span", [
                              _vm._v(
                                "保费合计：" + _vm._s(_vm.totalPrice) + "元"
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "el-row",
                          { attrs: { justify: "center", type: "flex" } },
                          [
                            !_vm.formEmployee.isSubmitted
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      loading: _vm.formEmployee.isLoading,
                                      icon: "el-icon-check",
                                      type: "primary",
                                    },
                                    on: { click: _vm.submitEmployee },
                                  },
                                  [_vm._v("\n\t\t\t\t\t\t\t确认\n\t\t\t\t\t\t")]
                                )
                              : _vm._e(),
                            _vm.formEmployee.isSubmitted
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { icon: "el-icon-edit" },
                                    on: { click: _vm.handleEmployeeModify },
                                  },
                                  [_vm._v("\n\t\t\t\t\t\t\t修改\n\t\t\t\t\t\t")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                    ],
                    2
                  )
                : _vm._e(),
              _vm.isInitOver
                ? _c(
                    "el-card",
                    { attrs: { header: "开具发票" } },
                    [
                      _c("invoice-form", {
                        ref: "invoice",
                        attrs: {
                          insureType: _vm.product.type,
                          supportSpecial:
                            _vm.product.invoice.supportSpecialInvoice,
                        },
                        on: {
                          onSubmitted: _vm.onInvoiceSubmitted,
                          onUnsubmitted: function ($event) {
                            _vm.formSubmit.isInvoiceSubmitted = false
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isEndorsement && _vm.isInitOver
                ? [
                    _c("custom-notice", {
                      ref: "custom_notice",
                      attrs: {
                        insureType: _vm.product.type,
                        isShowPdf: _vm.product.isShowPdfInsured,
                        productId: _vm.product.id,
                      },
                      on: { onInsureReadOver: _vm.onInsureReadOver },
                    }),
                    _vm.isShowInsuredBtn
                      ? _c(
                          "el-card",
                          { attrs: { header: "投保人声明" } },
                          [
                            _c(
                              "el-alert",
                              { attrs: { closable: false, type: "error" } },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-size": "1.125em",
                                      "font-weight": "bold",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "为保障您的合法权益，请您仔细阅读后勾选确认"
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "el-row",
                              { attrs: { justify: "start", type: "flex" } },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "formView",
                                    staticStyle: { "margin-top": "10px" },
                                  },
                                  [
                                    _c(
                                      "el-checkbox-group",
                                      {
                                        model: {
                                          value: _vm.checkListStatement,
                                          callback: function ($$v) {
                                            _vm.checkListStatement = $$v
                                          },
                                          expression: "checkListStatement",
                                        },
                                      },
                                      [
                                        _c("el-checkbox", {
                                          attrs: {
                                            label:
                                              "本投保人已完整阅读并了解投保须知内容及投保险种的保险条款内容，尤其是对其中免除保险人责任的条款或约定（包括但不限于责任免除、投保人被保险人义务、保险金申请与给付等），本投保人已充分理解并接受上述内容，同意以此作为订立保险合同的依据。",
                                          },
                                        }),
                                        _c("el-checkbox", {
                                          attrs: {
                                            label:
                                              "投保时，本投保人已就该产品的保障内容及保险金额等向被保险人进行了明确说明，并征得其同意。",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _c(
                              "el-row",
                              {
                                staticStyle: { "margin-top": "5px" },
                                attrs: { justify: "center", type: "flex" },
                              },
                              [
                                _c("el-tag", { attrs: { type: "" } }, [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-size": "1.125em",
                                        "font-weight": "bold",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "请滑动鼠标至底部，阅读并确认全部内容"
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("p"),
                              ],
                              1
                            ),
                            _c(
                              "el-row",
                              { attrs: { justify: "center", type: "flex" } },
                              [
                                !_vm.product.isShowPdfInsured
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { plain: "", type: "primary" },
                                        on: { click: _vm.handleAddStaging },
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t暂存保单\n\t\t\t\t\t\t"
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "el-button",
                                      {
                                        attrs: { plain: "", type: "primary" },
                                        on: { click: _vm.onBackInsured },
                                      },
                                      [_vm._v("查看投保须知")]
                                    ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      disabled: !_vm.everythingConfirmed,
                                      type: "primary",
                                    },
                                    on: { click: _vm.handleStepConfirm },
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t我已逐条阅读并同意投保\n\t\t\t\t\t\t"
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("float-btn", {
                      attrs: { loading: _vm.isAddStaging, text: "暂存保单" },
                      on: { onFloatBtnClicked: _vm.handleAddStaging },
                    }),
                  ]
                : [
                    _c(
                      "el-row",
                      { attrs: { justify: "center", type: "flex" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              disabled: !_vm.everythingConfirmed,
                              loading: _vm.isCheckingInsure,
                              type: "primary",
                            },
                            on: { click: _vm.handleStepConfirm },
                          },
                          [_vm._v("\n\t\t\t\t\t\t同意投保>>\n\t\t\t\t\t")]
                        ),
                      ],
                      1
                    ),
                  ],
            ],
            2
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "", name: "1" } },
            [
              _vm.isInitOver
                ? [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          [
                            _c(
                              "el-card",
                              { attrs: { header: "投保信息" } },
                              [
                                _c(
                                  "div",
                                  { attrs: { slot: "header" }, slot: "header" },
                                  [
                                    _c("span", [_vm._v("投保信息")]),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          float: "right",
                                          "font-weight": "bold",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t保费合计：\n\t\t\t\t\t\t\t\t\t"
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "font-weight": "bold",
                                              "font-size": "1.25em",
                                              color: "red",
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.totalPrice))]
                                        ),
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t元\n\t\t\t\t\t\t\t\t"
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm.product.isInsureCar
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "avue-crud",
                                          {
                                            attrs: {
                                              data: _vm.formSubmit.vehs,
                                              option: _vm.optionEmployeeView,
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "menuLeft" },
                                              [
                                                _c("div", [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        this.formSubmit.toubao
                                                          .certType === "100"
                                                          ? "联系人"
                                                          : "企业名称"
                                                      ) +
                                                      "：\n\t\t\t\t\t\t\t\t\t\t\t"
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "font-weight": "bold",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.formSubmit.toubao
                                                            .unit_name
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                                _vm.formSubmit.toubao
                                                  .certType === "100"
                                                  ? _c("div", [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t\t身份证号：\n\t\t\t\t\t\t\t\t\t\t\t"
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            "font-weight":
                                                              "bold",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.formSubmit
                                                                .toubao
                                                                .unit_code
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _c("div", [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t保障时间：自\n\t\t\t\t\t\t\t\t\t\t\t"
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "font-weight": "bold",
                                                        color: "red",
                                                        margin: "10px 0",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.formSubmit
                                                              .strEffectiveDate
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t起至\n\t\t\t\t\t\t\t\t\t\t\t"
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "font-weight": "bold",
                                                        color: "red",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.formSubmit
                                                            .strExpiryDate
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t止\n\t\t\t\t\t\t\t\t\t\t"
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    )
                                  : _c(
                                      "div",
                                      [
                                        _c(
                                          "avue-crud",
                                          {
                                            ref: "crudCheckInsure",
                                            attrs: {
                                              data: _vm.dataEmployee,
                                              option: _vm.optionEmployeeView,
                                              page: _vm.page,
                                            },
                                            on: {
                                              "update:page": function ($event) {
                                                _vm.page = $event
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "profession",
                                                  fn: function (scope) {
                                                    return [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.getProfessionName(
                                                              scope.row
                                                                .profession
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "remark",
                                                  fn: function (scope) {
                                                    return [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            color: "red",
                                                            "font-weight":
                                                              "bold",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row.remark
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              517547007
                                            ),
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "menuLeft" },
                                              [
                                                _c("div", [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t企业名称：\n\t\t\t\t\t\t\t\t\t\t\t"
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "font-weight": "bold",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.formSubmit.toubao
                                                            .unit_name
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t保障时间：自\n\t\t\t\t\t\t\t\t\t\t\t"
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "font-weight": "bold",
                                                        color: "red",
                                                        margin: "10px 0",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.formSubmit
                                                              .strEffectiveDate
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t起至\n\t\t\t\t\t\t\t\t\t\t\t"
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "font-weight": "bold",
                                                        color: "red",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.formSubmit
                                                            .strExpiryDate
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t止\n\t\t\t\t\t\t\t\t\t\t"
                                                  ),
                                                ]),
                                                !_vm.isEndorsement
                                                  ? _c("div", [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t\t保障期限：\n\t\t\t\t\t\t\t\t\t\t\t"
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "red-bold",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.formSubmit
                                                                .term
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t\t个月\n\t\t\t\t\t\t\t\t\t\t"
                                                      ),
                                                    ])
                                                  : _c("div", [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t\t保障天数：\n\t\t\t\t\t\t\t\t\t\t\t"
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "red-bold",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.formSubmit
                                                                .term
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t\t天\n\t\t\t\t\t\t\t\t\t\t"
                                                      ),
                                                    ]),
                                              ]
                                            ),
                                            _c(
                                              "template",
                                              { slot: "coverage" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formSubmit.coverage
                                                    ) + "万"
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                _c("invoice-view", {
                                  ref: "invoiceView",
                                  staticStyle: { "margin-top": "20px" },
                                  attrs: { insureType: _vm.product.type },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { justify: "center", type: "flex" } },
                      [
                        _c(
                          "el-button",
                          { on: { click: _vm.handleStepInsure } },
                          [_vm._v("<<上一步，修改保单")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              loading: _vm.isCheckingInsure,
                              type: "primary",
                            },
                            on: { click: _vm.handleStepPay },
                          },
                          [_vm._v("下一步，去支付>>")]
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "", name: "2" } },
            [
              _vm.currentStep === "2"
                ? [
                    _c(
                      "el-row",
                      {
                        attrs: { gutter: 20, justify: "center", type: "flex" },
                      },
                      [
                        _vm.allowOnline
                          ? _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-card",
                                  {
                                    staticStyle: { height: "450px" },
                                    attrs: { header: "在线支付" },
                                  },
                                  [
                                    _c(
                                      "el-row",
                                      {
                                        staticStyle: {
                                          "margin-bottom": "10px",
                                        },
                                        attrs: {
                                          justify: "start",
                                          type: "flex",
                                        },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            "通过线上付款的方式支付保费：" +
                                              _vm._s(_vm.totalPrice) +
                                              "元"
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "el-row",
                                      {
                                        attrs: {
                                          justify: "start",
                                          type: "flex",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "formView" },
                                          [
                                            _c(
                                              "el-checkbox",
                                              {
                                                model: {
                                                  value:
                                                    _vm.payOnlineWarningChecked,
                                                  callback: function ($$v) {
                                                    _vm.payOnlineWarningChecked =
                                                      $$v
                                                  },
                                                  expression:
                                                    "payOnlineWarningChecked",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t我已知悉：选择该支付方式后，如果再通过其他支付方式转账给保险公司，保险公司无法生成电子保单，后果自负。如果重新选择线下对公转账，必须重新登录。\n\t\t\t\t\t\t\t\t\t"
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-row",
                                      {
                                        staticStyle: { "margin-top": "20px" },
                                        attrs: {
                                          justify: "center",
                                          type: "flex",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              disabled:
                                                !_vm.payOnlineWarningChecked,
                                              loading: _vm.isPay,
                                              round: "",
                                              size: "medium",
                                              type: "success",
                                            },
                                            on: { click: _vm.onPayOnline },
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t马上支付\n\t\t\t\t\t\t\t\t"
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.isShowOfflinePayFan && _vm.allowOffline
                          ? _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-card",
                                  {
                                    staticStyle: { height: "450px" },
                                    attrs: { header: "对公打款" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "margin-bottom": "10px",
                                        },
                                      },
                                      [_vm._v("对公转账须知：")]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "margin-bottom": "10px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formPayOffline.refusePrompt
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-row",
                                      {
                                        staticStyle: {
                                          "margin-bottom": "10px",
                                        },
                                        attrs: {
                                          justify: "start",
                                          type: "flex",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "formView" },
                                          [
                                            _c(
                                              "el-checkbox",
                                              {
                                                model: {
                                                  value:
                                                    _vm.payOfflineWarning1Checked,
                                                  callback: function ($$v) {
                                                    _vm.payOfflineWarning1Checked =
                                                      $$v
                                                  },
                                                  expression:
                                                    "payOfflineWarning1Checked",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "我已知悉：" +
                                                    _vm._s(
                                                      _vm.formPayOffline.remind
                                                    )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "el-checkbox",
                                              {
                                                staticStyle: {
                                                  "margin-top": "5px",
                                                },
                                                model: {
                                                  value:
                                                    _vm.payOfflineWarning2Checked,
                                                  callback: function ($$v) {
                                                    _vm.payOfflineWarning2Checked =
                                                      $$v
                                                  },
                                                  expression:
                                                    "payOfflineWarning2Checked",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t我已知悉：对公转账须以企业对公账户打款，且转账金额须与保单保费一致。如以个人账户打款，或金额不一致，保险公司无法确认收款，保单无法生效。\n\t\t\t\t\t\t\t\t\t"
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-row",
                                      {
                                        staticStyle: { "margin-top": "20px" },
                                        attrs: {
                                          justify: "center",
                                          type: "flex",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              disabled:
                                                !_vm.payOfflineWarning1Checked ||
                                                !_vm.payOfflineWarning2Checked,
                                              loading: _vm.isPay,
                                              round: "",
                                              size: "medium",
                                              type: "success",
                                            },
                                            on: { click: _vm.handlePayOffline },
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t对公打款\n\t\t\t\t\t\t\t\t"
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { justify: "center", type: "flex" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { disabled: _vm.isPay },
                            on: { click: _vm.handleStepConfirm },
                          },
                          [_vm._v("<<上一步，确认保单")]
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "", name: "3" } },
            [
              _vm.currentStep === "3"
                ? [
                    _vm.paySource == 1
                      ? _c(
                          "el-row",
                          [
                            _c(
                              "el-row",
                              { attrs: { justify: "center", type: "flex" } },
                              [
                                _c("el-col", { attrs: { span: 12 } }, [
                                  _vm._v("提交成功"),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "el-row",
                              { attrs: { justify: "center", type: "flex" } },
                              [
                                _c("el-col", { attrs: { span: 12 } }, [
                                  _vm._v("正在获取保险公司系统的支付结果..."),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "el-row",
                              { attrs: { justify: "center", type: "flex" } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t如果您还未完成支付，请\n\t\t\t\t\t\t\t"
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          loading: _vm.isPay,
                                          type: "primary",
                                        },
                                        on: { click: _vm.onDealPay },
                                      },
                                      [_vm._v("继续支付")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-row",
                              { attrs: { justify: "center", type: "flex" } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t如果您已完成支付，请\n\t\t\t\t\t\t\t"
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "success" },
                                        on: { click: _vm.handleViewPolicy },
                                      },
                                      [_vm._v("查看保单详情")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.paySource == 2
                      ? _c(
                          "el-row",
                          [
                            _c(
                              "el-row",
                              { attrs: { justify: "center", type: "flex" } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c("el-alert", {
                                      attrs: {
                                        title: _vm.formPayOffline.refusePrompt,
                                        type: "warning",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-row",
                              { attrs: { justify: "center", type: "flex" } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c(
                                      "avue-form",
                                      {
                                        attrs: { option: _vm.optionPayOffline },
                                        on: {
                                          submit: _vm.submitTransferCertificate,
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "accountName",
                                              fn: function (scope) {
                                                return [
                                                  _c("span", [
                                                    _vm._v(_vm._s(scope.value)),
                                                  ]),
                                                ]
                                              },
                                            },
                                            {
                                              key: "accountOpening",
                                              fn: function (scope) {
                                                return [
                                                  _c("span", [
                                                    _vm._v(_vm._s(scope.value)),
                                                  ]),
                                                ]
                                              },
                                            },
                                            {
                                              key: "account",
                                              fn: function (scope) {
                                                return [
                                                  _c("span", [
                                                    _vm._v(_vm._s(scope.value)),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          454514768
                                        ),
                                        model: {
                                          value: _vm.formPayOffline,
                                          callback: function ($$v) {
                                            _vm.formPayOffline = $$v
                                          },
                                          expression: "formPayOffline",
                                        },
                                      },
                                      [
                                        _c(
                                          "template",
                                          { slot: "certificate" },
                                          [
                                            _c(
                                              "el-upload",
                                              {
                                                staticClass: "avatar-uploader",
                                                attrs: {
                                                  "auto-upload": false,
                                                  "before-upload":
                                                    _vm.beforeTransferCertificateUpload,
                                                  "on-change":
                                                    _vm.onTransferCertificateChange,
                                                  "on-success":
                                                    _vm.handleTransferCertificateSuccess,
                                                  "show-file-list": false,
                                                  action: "",
                                                },
                                              },
                                              [
                                                _vm.imageTransferCertificate
                                                  ? _c("img", {
                                                      staticClass: "avatar",
                                                      attrs: {
                                                        src: _vm.imageTransferCertificate,
                                                      },
                                                    })
                                                  : _c("i", {
                                                      staticClass:
                                                        "el-icon-plus avatar-uploader-icon",
                                                    }),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.repeatEmpListDialogVisible,
            title: "提示",
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.repeatEmpListDialogVisible = $event
            },
          },
        },
        [
          _c(
            "avue-crud",
            {
              ref: "crud",
              attrs: {
                data: _vm.repeatEmpList,
                option: _vm.optionRepeatEmployee,
                "table-loading": _vm.tableLoadingRepeatEmpList,
              },
            },
            [
              _c(
                "template",
                { slot: "menuLeft" },
                [
                  _vm._v("\n\t\t\t\t当前被保企业：\n\t\t\t\t"),
                  _c("span", { staticStyle: { "font-weight": "bold" } }, [
                    _vm._v(_vm._s(_vm.formSubmit.beibao.unit_name)),
                  ]),
                  _c("el-alert", {
                    attrs: {
                      title:
                        "以下投保人员已通过其他企业投保，请确认是否需要再次投保？",
                      type: "warning",
                    },
                  }),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.repeatEmpListDialogVisible = false
                    },
                  },
                },
                [_vm._v("修改投保人员")]
              ),
              _c("el-button", { on: { click: _vm.handleConfirmInsure } }, [
                _vm._v("确认再次投保"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("repeat-emps-dlg", {
        ref: "repeatEmpsDlg",
        on: { removeRepeatEmps: _vm.handleRemoveRepeatEmps },
      }),
      _c("repeat-car-dlg", { ref: "repeatCarDlg" }),
      _c("payer-info", {
        ref: "payerInfo",
        on: { onPayerInfo: _vm.onPayerInfo },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "show-close": false,
            top: "25vh",
            visible: _vm.maintenanceFlag,
            title: "操作须知",
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.maintenanceFlag = $event
            },
          },
        },
        [
          _c("div", [
            _vm._v("\n\t\t\t如何替换、加人，您知道了吗？\n\t\t\t"),
            _c("br"),
            _vm._v("\n\t\t\t如何制作精美的投保计划书，您知道吗？\n\t\t\t"),
            _c("br"),
            _vm._v("\n\t\t\t职业、工种的投保方案建议，您知道吗？\n\t\t\t"),
            _c("br"),
            _c("span", { staticStyle: { color: "red" } }, [
              _vm._v(
                "为了更顺畅地使用本系统，提醒您尽快完成本系统的操作指引的阅读，解锁更多实用功能！"
              ),
            ]),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.goNewGuidance },
                },
                [_vm._v("马上了解")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "default" },
                  on: {
                    click: function ($event) {
                      _vm.maintenanceFlag = false
                    },
                  },
                },
                [_vm._v("太忙了，稍后再看")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("XsmYinLiuDialog", {
        ref: "refXsmYinLiu",
        attrs: {
          interData: {
            orderId: _vm.orderId,
            act: _vm.act,
            stagingId: _vm.stagingId,
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }